import React from "react";
import { Box, Typography } from "@mui/material";
import Slider from "react-slick";
import { Grid } from "@mui/material";
import Slide from "./Slide";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GroupRow = ({
  name,
  playlist,
}) => {
  const maxItem = 50;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    playlist.length > 0 && (
      <Grid container spacing={2} sx={{ marginTop: "1rem" }}>
        <Grid item xs={12}>
          <Box sx={{ paddingBottom: "1rem" }} className="parent">
            <Typography
              sx={{
                fontSize: "1.25rem",
                fontWeight: 600,
                lineHeight: 0.2,
                marginTop: 0,
                color: "white",
                pl: 5,
                textDecorationColor: "transparent",
                transition: "text-decoration-color 0.5s ease",
                "&:focus, &:hover": {
                  textDecorationColor: "white",
                },
              }}
            >
              {name}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} padding={0}>
          <Box
            sx={{
              position: "relative",
              margin: "0 2rem",
              "& .slick-slide": {
                padding: "0 0.25rem",
              },
            }}
          >
            <Slider {...settings}>
              {playlist.slice(0, maxItem).map((x, id) => (
                <Slide
                  id={id}
                  key={"vod" + (x.stream_id || x.series_id)}
                  name={x.name}
                  stream_icon={x.stream_icon || x.movie_image}
                  stream_id={x.stream_id || x.series_id}
                  stream_url={x.direct_source}
                  category_id={x.category_id}
                  container_extension={x.container_extension}
                  last={id + 1 === maxItem}
                  existingTmdb={x.tmdb}
                />
              ))}
            </Slider>
          </Box>
        </Grid>
      </Grid>
    )
  );
};

export default GroupRow;
